module.exports = __webpack_public_path__ + "img/lock.bdf48274.gif";